import React, { Component } from 'react';
import { graphql } from 'react-relay';
import DistributionBarChart from '../../../../components/DistributionBarChart';
import NpsGauge from '../../../../components/NpsGauge';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query NpsGaugeDistributionWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          useNumbers
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              count
              ...NpsGauge_answersReport
              ...DistributionBarChart_answersReport
            }
            ...DistributionBarChart_question
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter()
class NpsGaugeDistributionWidget extends Component {
  render() {
    const styles = {
      left: {
        display: 'inline-block',
        width: this.props.width * 2 / 5,
      },
      right: {
        display: 'inline-block',
        width: (this.props.width * 3 / 5) - 1, // -1 to make sure both always fit
      },
    };
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <div>
        <div style={styles.left}>
          <NpsGauge
            answersReport={question.answersReport}
            height={this.props.bodyHeight}
            width={this.props.width * 2 / 5}
            uniqueId={widget.id + '-npsgauge'}
          />
        </div>
        <div style={styles.right}>
          <DistributionBarChart
            question={question}
            answersReport={question.answersReport}
            height={this.props.bodyHeight}
            width={this.props.width * 3 / 5}
            colorBars={true}
            collapseNps={true}
            uniqueId={widget.id + '-distribution'}
            widgetConfig={widget.config || {}}

          />
        </div>
      </div>
    );
  }
}

export default NpsGaugeDistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsGaugeDistributionWidget/NpsGaugeDistributionWidget.js